import { useMutation, useQueryClient } from '@tanstack/react-query'
import { generateInvoices } from 'api/admin/charges/generateInvoices'
import { chargesKeys } from './keys'

export const useGenerateInvoicesMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof generateInvoices>[0]) =>
      generateInvoices(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: chargesKeys.all })
    },
  })
}
